<template>
  <div class="d-flex flex-column result-display">
    <div class="sortition-name text-center text">
			<span class="name-part" v-for="namePart in result.sortition.name.split(' ')"
				:key="namePart">
				{{  namePart }}
			</span>
    </div>
    <div class="sortition-date text-center text">{{ result.date }}</div>
    <v-row no-gutters>
      <v-col md="6" lg="6" class="align-self-center border-right">
        <v-row no-gutters>
          <v-col>
            <result-digit-display
              :value="result.first"
              text="1st"
              left
            ></result-digit-display>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <result-digit-display
              :value="result.second"
              text="2nd"
              left
            ></result-digit-display>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col>
            <result-digit-display
              :value="result.third"
              text="3rd"
              left
            ></result-digit-display>
          </v-col>
        </v-row>
      </v-col>
      <v-col md="6" lg="6">
        <v-row v-if='result.pickTwo'  no-gutters>
          <v-col cols="12">
            <v-img height="30" contain src="./images/pick2.png" />
          </v-col>
          <v-col cols="12">
            <result-digit-display
              class="d-flex justify-center"
              :value="result.pickTwo"
            ></result-digit-display>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12">
            <v-img height="30" contain src="./images/pick3.png" />
          </v-col>
          <v-col cols="12">
            <result-digit-display
              class="d-flex justify-center"
              :value="result.cashThree"
            ></result-digit-display>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12">
            <v-img height="30" contain src="./images/pick4.png" />
          </v-col>
          <v-col cols="12">
            <result-digit-display
              class="d-flex justify-center"
              :value="result.pickFour"
            ></result-digit-display>
          </v-col>
        </v-row>
        <v-row v-if="result.pickFive" no-gutters>
          <v-col cols="12">
            <v-img height="30" contain src="./images/pick5.png" />
          </v-col>
          <v-col cols="12">
            <result-digit-display
              class="d-flex justify-center"
              :value="result.pickFive"
            ></result-digit-display>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import ResultDigitDisplay from "./ResultDigitDisplay.vue";

export default {
  name: "ResultDisplay",
  components: { ResultDigitDisplay },
  props: {
    result: {
      type: Object,
      required: true
    }
  }
};
</script>
<style scoped lang="scss">
@import "css/variables";

.result-display {
	background-color: white;
	color: black;
	padding: 5px;
	border-radius: 10%;
}

.sortition-name {
  line-height: 25px;
  font-size: 1.5rem;
  font-weight: bold;
}

.text {
  color: $font-color-3;
}

.next-drawing-text {
  color: $font-color;
}

.sortition-date {
  font-size: 1.0rem;
}

.first,
.second,
.third {
  display: flex;
  flex-direction: column;
  margin-top: 0;

  .header {
    line-height: 35px;
    text-align: center;
  }
}

  .border-right {
    padding-right: 15px;
    border-right: white solid 5px;
  }
	.name-part:nth-child(odd) {
		color: $font-color-3;
	}
	.name-part:nth-child(even) {
		color: $font-color-2;
	}
</style>
